import React from "react";
import "../css/contactus.scss";

function Contact() {
  return (
    <div className="contact">
      <div className="container">
        <h1>Contact Us</h1>
        <div className="contact-intro-2">
          <p style={{ fontWeight: 500 }}>
            The best way to get assistance with your online or telephone order
            is to contact our Customer Services team, rather than visiting our
            stores.
          </p>
          <p style={{ fontWeight: 500 }}>
            We’re here to help, however you need us, and we have a whole host of
            ways you can get in touch.
          </p>
          <p style={{ fontWeight: 500 }}>
            Our Live Messaging virtual assistant is also available 24/7 to
            answer any query, please use our help function accessible on the
            homepage.
          </p>
          <p style={{ fontWeight: 500 }}>
            Otherwise, simply choose your preferred method from the options
            below.
          </p>
          <p style={{ fontWeight: 500 }}>
            Email us at{" "}
            <a href="mailto:level@failblossom.lifestyle">
              level@failblossom.lifestyle
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
